import { Animation, AnimationController } from '@ionic/angular';
import { iosTransitionAnimation, mdTransitionAnimation } from '@ionic/core';

export const navAnimation = (baseEl: HTMLElement, opts?: any): Animation => {
  // default animation
  if (opts.mode === 'ios') {
    return iosCustomTransitionAnimation(baseEl, opts);
  } else {
    return mdTransitionAnimation(baseEl, opts);
  }
};

const iosCustomTransitionAnimation = (baseEl, opts): Animation => {
  const animationCtrl = new AnimationController();
  const direction: 'forward' | 'back' = opts.direction;
  const leavingAnimationElements: HTMLElement[] = animationElements(opts, 'leaving');
  const enteringAnimationElements: HTMLElement[] = animationElements(opts, 'entering');
  const leavingAnimations: Animation[] = [];
  const enteringAnimations: Animation[] = [];
  if (direction === 'forward') {
    for (const el of enteringAnimationElements) {
      const animation = animationCtrl.create()
        .addElement(el)
        .duration(200)
        .fromTo('opacity', 0, 1);
      enteringAnimations.push(animation);
    }
  } else {
    for (const el of leavingAnimationElements) {
      const animation = animationCtrl.create()
        .addElement(el)
        .duration(150)
        .fromTo('opacity', 1, 0);
      leavingAnimations.push(animation);
    }
  }
  return animationCtrl.create()
    .addAnimation([iosTransitionAnimation(baseEl, opts), ...leavingAnimations, ...enteringAnimations])
};

const animationElements = (opts, type: 'leaving' | 'entering'): HTMLElement[] => {
  const result: HTMLElement[] = [];
  const headerElement = type === 'leaving' ? opts.leavingEl.querySelector('ion-header') : opts.enteringEl.querySelector('ion-header');
  if (headerElement) {
    result.push(headerElement);
  }
  return result;
}